/**
 * Created by slava on 02.02.17.
 */

const DonutBoxCellView = BaseCellView.extend({
    ctor: function (donutBox) {
        this._super();

        this.setContentSize(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        this.setAnchorPoint(0.5, 0.5);
        const image = new cc.Sprite(this.getImage(donutBox.lives));
        this.image = image;
        this.image.setPosition(this.width / 2, this.height / 2);
        this.addChild(image);

        this.animation = new cleverapps.Spine(bundles.donut_box.jsons.donutBox_spine_json);
        this.animation.setPosition(this.width / 2, this.height / 2);
        this.animation.setStartVisibleListener(() => {
            this.image.visible = false;
        });
        this.addChild(this.animation);

        this.initialize(donutBox);
    },

    getLivesId: function (lives) {
        return 4 - lives;
    },

    getImage: function (lives) {
        return bundles.donut_box.frames[`donutBox_${this.getLivesId(lives)}`];
    },

    initialize: function (donutBox) {
        this._super(donutBox);

        this.image.setVisible(true);
        this.animation.setVisible(false);

        donutBox.onChangeLivesListener = this.createListener(this.changeLives.bind(this));
    },

    changeLives: function () {
        this.image.setSpriteFrame(this.getImage(this.cell.lives));
        const curLives = this.getLivesId(this.cell.lives);
        if (curLives > 0) {
            this.animation.setAnimation(0, `${curLives - 1}_${curLives}`, true);
            this.animation.setCompleteListener(() => {
                if (curLives === 4) {
                    this.animation.setCompleteListener();
                    this.animation.setAnimation(0, "idle_4", true);
                } else {
                    this.image.setVisible(true);
                    this.animation.setVisible(false);
                }
            });
        } else {
            this.image.setVisible(true);
            this.animation.setVisible(false);
        }
        cleverapps.effects.fire("donut_box.fill");
    },

    unuse: function () {
        this.cell.onChangeLivesListener = function () {};

        this._super();
    },

    openAnimation: function () {
        const realZOrder = this.getLocalZOrder();
        this.setLocalZOrder(2);
        this.animation.setCompleteListener();
        this.animation.setAnimation(0, "open", false);

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.CallFunc(() => { 
                cleverapps.effects.fire("donut_box.open");
            })
        ));

        this.runAction(new cc.Sequence(
            new cc.DelayTime(1.7),
            new cc.CallFunc(() => {
                this.setLocalZOrder(realZOrder);
                this.image.setVisible(true);
                this.animation.setVisible(false);
            })
        ));
    },

    hurtAnimation: function () {
    }
});